import type { ReactNode } from 'react';
import styles from './Card.module.css';

interface CardProps {
    children: ReactNode;
    title?: string;
    subtitle?: string;
    action?: ReactNode;
    variant?: 'default' | 'compact' | 'noPadding';
    className?: string;
}

export function Card({
    children,
    title,
    subtitle,
    action,
    variant = 'default',
    className = '',
}: CardProps) {
    const classes = [
        styles.card,
        variant !== 'default' ? styles[variant] : '',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={classes}>
            {(title || action) && (
                <div className={styles.header}>
                    <div>
                        {title && <h3 className={styles.title}>{title}</h3>}
                        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    </div>
                    {action && <div className={styles.action}>{action}</div>}
                </div>
            )}
            {children}
        </div>
    );
}
